<template>
  <div class="hero">

    <div class="hero__wrapper">
      <h1 class="hero__title">
        natjecateljsko<br>
        <span class="hero__accent" :class="{ 'hero__accent--orange': msg === 'suncobran' }">{{ msg }}</span>iranje
      </h1>
      <p class="hero__lead">Pokrij sve ljude na plaži okruglim suncobranima i osvoji nagrade.</p>
    </div>

    <Decorator class="hero__decorator" />

  </div>
</template>
<script>
import Decorator from '@/components/Decorator'
export default {
  components: {
    Decorator
  },
  data() {
    return {
      msg: 'suncobran'
    }
  },
  mounted() {
    setInterval(() => {
      this.msg = this.msg === 'suncobran' ? 'program' : 'suncobran'
    }, 1000)
  }
}
</script>
